import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import type { User } from "@/types";

export function RequireAuth({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!token || !user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export function RequireStaff({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user?.is_staff) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export function RequirePermission({
  permission,
  children,
}: {
  permission: keyof NonNullable<User["role"]>;
  children: ReactNode;
}) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/" replace />;
  if (user.is_staff) return <>{children}</>;
  if (!user.role?.[permission]) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
